// eslint-disable-next-line max-classes-per-file
import { checkExistValue } from "@/utils/common/validateHelper/validateUtils";

// eslint-disable-next-line max-classes-per-file
export interface RequestRecommendInterface {
  limit: string;
  checkin?: string;
  checkout?: string;
}

class Review {
  rating: string;

  text_rating_detail: string;

  num_reviews: string;

  textRatingDetail?: string;

  numReviews?: number;

  constructor(data: any) {
    this.rating = data.rating || "false";
    this.text_rating_detail = data.text_rating_detail || "";
    this.num_reviews = data.num_reviews || "";
    this.textRatingDetail = data.textRatingDetail || "";
    this.numReviews = data.numReviews || null;
  }
}

export class HotelRecommend {
  id: number;

  images: string[];

  title: string;

  hotel_star: number;

  review: Review;

  location: string;

  latitude: number;

  longitude: number;

  isFavourite: boolean;

  countrySlug: string;

  citySlug: string;

  areaSlug: string;

  hotelSlug: string;

  hotelSlugPath: string;

  isGreenCertificate?: boolean;

  specialDeal: boolean;

  recommend: boolean;

  perk: string = "";

  isSpecialDeal?: boolean;

  isRecommend?: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.images = data.images || [];
    this.title = data.title || "";
    this.hotel_star = data.hotel_star || 0;
    this.review = data.review || [];
    this.location = data.location || 0;
    this.latitude = data.latitude || 0;
    this.longitude = data.longitude || 0;
    this.isFavourite = data.isFavourite || false;
    this.countrySlug = data.countrySlug || "";
    this.citySlug = data.citySlug || "";
    this.areaSlug = data.areaSlug || "";
    this.hotelSlug = data.hotelSlug || "";
    this.hotelSlugPath = `${this.countrySlug}/${this.citySlug}/${this.areaSlug}/${this.hotelSlug}`;
    this.isGreenCertificate = data.isGreenCertificate || false;
    this.specialDeal = data.specialDeal || false;
    this.recommend = data.recommend || false;
    this.perk = data?.perk ?? data?.perks ?? this.perk;
    this.isSpecialDeal = data?.isSpecialDeal || false;
    this.isRecommend = data?.isRecommend || false;
  }
}

export class ResponseRecommendInterface {
  hotels: HotelRecommend[];

  total: number;

  constructor(data: any) {
    this.hotels =
      data && checkExistValue(data.hotels) && data.hotels.length > 0
        ? data.hotels.map((hotels: any) => new HotelRecommend(hotels))
        : [];

    this.total = data.total || 0;
  }
}
